module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/hero-67b97959b98a38bff3eedcfd76229620.jpg";